import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { RichEditor } from "@/components/rich/RichEditor";
import { api, errMsg } from "@/lib/api";

export const SceneDialog = ({ uid, scene, onClose, onSaved }) => {
  const [title, setTitle] = useState(scene?.title || "");
  const [content, setContent] = useState(scene?.content || "");
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      const body = { title: title.trim(), content };
      const r = scene?.id ? await api.patch(`/scenes/${scene.id}`, body) : await api.post(`/universes/${uid}/scenes`, body);
      toast.success(scene?.id ? "Scene saved" : "Scene note created");
      onSaved?.(r.data);
      onClose();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-2xl" data-testid="scene-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">{scene?.id ? "Edit scene" : "New scene note"}</DialogTitle>
          <DialogDescription>Sketch a scene you want to use. Place it on a storyboard as a placeholder; it never counts toward word totals.</DialogDescription>
        </DialogHeader>
        <Input value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Scene title, e.g. Duel on the cliffs" data-testid="scene-title-input" />
        <div className="rounded-md border border-[#2D3442]"><RichEditor value={content} onChange={setContent} placeholder="What happens, who's there, why it matters…" testid="scene-content" /></div>
        <DialogFooter>
          <Button variant="ghost" onClick={onClose} data-testid="scene-cancel">Cancel</Button>
          <Button onClick={save} disabled={busy || !title.trim()} data-testid="scene-save">Save scene</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
